var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRodeoRTrimmed = function SvgRodeoRTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 332 332"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 166,
    r: 166,
    fill: "#FFDE59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A21081",
    d: "m241.071 213.345-99.52-106.737v90.825l47.142 51.439C196.55 257.831 202.707 262 213.189 262h4.93c29.731 0 38.667-33.056 22.952-48.655Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4F085E",
    d: "M179.284 70H97.953a20.96 20.96 0 0 0-8.045 1.628 21.004 21.004 0 0 0-6.81 4.595 21.067 21.067 0 0 0-4.532 6.86A21.111 21.111 0 0 0 77 91.161v149.985a20.807 20.807 0 0 0 1.56 7.994 20.752 20.752 0 0 0 11.265 11.296 20.653 20.653 0 0 0 7.973 1.563h22.954a20.657 20.657 0 0 0 7.973-1.563 20.693 20.693 0 0 0 6.76-4.519 20.76 20.76 0 0 0 4.506-6.777 20.843 20.843 0 0 0 1.559-7.994v-43.713h37.734c49.298 0 74.871-16.987 74.871-60.4.01-48.65-28.018-67.033-74.871-67.033Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD4CB7",
    d: "m220.581 191.407-79.03-84.801v90.825h37.744c16.485 0 30.196-2.007 41.286-6.024Z"
  })));
};
export default SvgRodeoRTrimmed;